module.exports = __webpack_public_path__ + "static/media/design-suite.7a2819ea.png";